import Marquee from "react-fast-marquee";
import { Reveal } from "./Reveal";

const promises = [
  "We go at their pace.",
  "Mistakes happen. That's how you learn.",
  "More than just passing a test.",
  "Drive awake. Arrive safe.",
  "Real skills for real roads.",
  "Calm, patient, supportive. Always.",
];

export default function Testimonials() {
  return (
    <section id="reviews" className="py-24 md:py-32 overflow-hidden">
      <div className="px-6 md:px-12 max-w-[1600px] mx-auto">
        <Reveal>
          <p className="text-sm font-bold uppercase tracking-[0.3em] text-[#F5B301] mb-6">04 — Our Promise</p>
          <h2 className="font-cabinet font-black uppercase tracking-tighter text-4xl md:text-6xl leading-[0.95] text-[#f5f5f0]">
            New school. <span className="text-[#F5B301]">Real values.</span>
          </h2>
          <p className="font-script text-2xl md:text-3xl text-white/60 mt-6 -rotate-1">No reviews yet — be our first success story.</p>
        </Reveal>
      </div>

      <div className="mt-16 select-none" data-testid="testimonials-marquee">
        <Marquee speed={28} gradient={false} pauseOnHover>
          {promises.map((text) => (
            <div key={text} className="flex items-center gap-8 mx-10">
              <span className="font-cabinet font-black uppercase tracking-tighter text-4xl md:text-6xl whitespace-nowrap text-[#f5f5f0]">
                {text}
              </span>
              <img
                src="/media/car-poster.jpg"
                alt="The Real Life Learners Kia Picanto"
                className="w-16 h-16 md:w-20 md:h-20 object-cover"
                loading="lazy"
              />
              <span className="text-[#F5B301] text-3xl">✦</span>
            </div>
          ))}
        </Marquee>
      </div>
    </section>
  );
}
